export default {
  adviceType: 'PNR',
  consideringSelectiveSchool: null,
  currentPrimarySchool: null, // pre-app
  student: null,
  intendedHighSchool: null,
  parentCarers: null
}
